import React from 'react';
import { constructCn } from '../../utilities/helperFunctions';

const LikeHeart = ({
    isActive = false,
    height = 15,
    width = 14,
    className = '',
}) => {
    const cn = constructCn(
        className,
        isActive && 'active',
        !isActive && 'inactive'
    );
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 15 14"
            height={height}
            width={width}
            className={cn}
        >
            <defs />
            {isActive ? (
                <path
                    fill="#E7C2ED"
                    d="M10.25.58a4.2 4.2 0 014.13 4.28c0 3.45-3.45 6.77-6.59 8.72-.16.1-.42.11-.58 0C4.05 11.65.63 8.32.63 4.87A4.2 4.2 0 014.75.58c1.06 0 2.02.42 2.75 1.1a4.03 4.03 0 012.75-1.1z"
                />
            ) : (
                <path
                    fill="#95989C"
                    d="M1.5 4.58c0 2.38 2.3 5.26 6 7.73 3.71-2.46 6-5.29 6-7.73a3.03 3.03 0 00-3-3.05c-.75 0-1.45.28-2 .77l-.72.66a.42.42 0 01-.56 0L6.5 2.3a2.95 2.95 0 00-2-.77c-1.66 0-3 1.36-3 3.05zm6-3.41a4.43 4.43 0 013-1.17C12.98 0 15 2.05 15 4.58c0 3.69-3.75 7.25-7.18 9.34a.65.65 0 01-.64 0C3.73 11.84 0 8.27 0 4.58A4.54 4.54 0 014.5 0c1.15 0 2.2.44 3 1.17z"
                />
            )}
        </svg>
    );
};

LikeHeart.displayName = 'LikeHeart';

export default React.memo(LikeHeart);
